<aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <div class="slimScrollDiv" style="position: relative; overflow: hidden; width: auto; height: 556px;">
        <section class="sidebar" style="height: 556px; overflow: hidden; width: auto;">
            <!-- sidebar menu: : style can be found in sidebar.less -->
            <ul class="sidebar-menu tree" data-widget="tree">
                <li class="header" i18n="@@Power BI">PowerBI</li>
                <li routerLinkActive="active"><a routerLink="/bi/report/list"><em class="fa fa-area-chart"></em> <span i18n="@@Reports">Reports</span></a></li>
                <li routerLinkActive="active"><a routerLink="bi/dashboard/list"><em class="fa fa-dashboard"></em> <span i18n="@@Dashboards">Dashboards</span></a></li>

                <li class="header" *ngIf="isCapaAdmin" i18n="@@Capa">CAPA</li>
                <li routerLinkActive="active"><a routerLink="capa" *ngIf="isCapaAdmin" class="active"><em class="fa fa-signal"></em> <span i18n="@@Licenses">Licenses</span></a></li>

                <li class="header" *ngIf="isAdminCLHUB" i18n="@@CLHUB">CLHUB</li>
                <li routerLinkActive="active"><a routerLink="/admin" *ngIf="isAdminCLHUB"><em class="fa fa-gears"></em> <span i18n="@@Administration">Power BI Viewer settings</span></a></li>
            </ul>
        </section>
    </div>
    <!-- /.sidebar -->
</aside>